import React from 'react';
import './../../../App.css';
import {Box, Grid, Typography, useTheme} from "@mui/material";
import {useGetNbaMatchups} from "../../../hooks/getNbaMatchups/getNbaMatchups";
import {useGetNflMatchups} from "../../../hooks/getNflMatchups/getNflMatchups";
import {NavBar} from "../../organisms/NavBar/NavBar";
import {SubNavbar} from "../../organisms/SubNavbar/SubNavbar";
import {BetboardTable} from "../../organisms/BetboardTable/BetboardTable";
import {useLocation} from "react-router-dom";
import {BetboardRow} from "../../../types/types";
import {LoadingTable} from "../../atoms/LoadingSkeleton/LoadingTable";
import {useGetNcaafbMatchups} from "../../../hooks/getNcaafbMatchups/getNcaafbMatchups";
import {TrendCardsColumn} from "../../organisms/TrendCardsColumn/TrendCardsColumn";
import {useGetDefaultTrends} from "../../../hooks/getDefaultTrends/getDefaultTrends";
import {useGetNcaabbMatchups} from "../../../hooks/getNcaabbMatchups/getNcaabbMatchups";
import {useAuth} from "../../../AuthContext/authContext";
import {useGetMlbMatchups} from "../../../hooks/getMlbMatchups/getMlbMatchups";
import {useGetSelectedSport} from "../../../hooks/utilHooks/useGetSelectedSport/useGetSelectedSport";

const HomePage = () => {

    const {getSelectedSport} = useGetSelectedSport()
    const sport = getSelectedSport()


    const {loggedInUserEmail} = useAuth();
    const {data: nbaData, error: nbaError, loading: nbaLoading}
        = useGetNbaMatchups(false, sport !== 'nba',  !!loggedInUserEmail) || {}
    // const {data: nflData, error: nflError, loading: nflLoading}
    //     = useGetNflMatchups(true, !isNflPage,  !!loggedInUserEmail) || {}
    const {data: nflData, error: nflError, loading: nflLoading}
        = useGetNflMatchups(true, sport !== 'nfl',  !!loggedInUserEmail) || {}
    const {data: ncaafbData, error: ncaafbError, loading: ncaafbLoading}
        = useGetNcaafbMatchups(false, sport !== 'ncaafb', !!loggedInUserEmail) || {}
    const {data: ncaabbData, error: ncaabbError, loading: ncaabbLoading}
        = useGetNcaabbMatchups(false, sport !== 'ncaabb', !!loggedInUserEmail) || {}
    const {data: mlbData, error: mlbError, loading: mlbLoading}
        = useGetMlbMatchups(sport !== 'mlb', !!loggedInUserEmail) || {}
    const {data: defaultTrendData, loading: defaultTrendsLoading} = useGetDefaultTrends(sport) || {};
    const theme = useTheme()
    const {nflMatchups = []} = nflData || {};
    const {nbaMatchups = []} = nbaData || {};
    const {ncaafbMatchups = []} = ncaafbData || {};
    const {ncaabbMatchups = []} = ncaabbData || {};
    const {mlbMatchups = []} = mlbData || {};
    const loading = nflLoading || nbaLoading || ncaafbLoading || ncaabbLoading || mlbLoading;
    const {defaultTrends} = defaultTrendData || {};
    const noGames = !nflMatchups.length && !nbaMatchups.length && !ncaafbMatchups.length && !ncaabbMatchups.length

    const updatingDatabaseMessage = (
        <Box
            style={{width: '100%', marginTop: '16px'}}
            display="flex"
            justifyContent="center"
        >
            <Typography
                variant="h6"
                style={{fontWeight: '100'}}
            >
                Updating Database - Check back soon
            </Typography>
        </Box>
    )

    return (
        <>
        <NavBar/>
            <Box maxWidth="xl" mx="auto" px={2}>
            <SubNavbar
                isNbaPage={sport === 'nba'}
                isHomePage={sport === 'nfl'}
                isNflPage={sport === 'nfl'}
                isNcaafbPage={sport === 'ncaafb'}
                isNcaabbPage={sport === 'ncaabb'}
                isMlbPage={sport === 'mlb'}
            />

        <Grid
            container
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            spacing={2}
            paddingLeft={{lg: 1}}
        >
            {loading ? <LoadingTable /> :
                <Grid
                    item
                    container
                    flex={1}
                    xl={8}
                    lg={8}
                    md={10}
                >
                    {sport === 'nba' ? nbaMatchups?.map((dayGroupedMatchups: BetboardRow[], index: number) =>
                            <BetboardTable
                                label={'NBA'}
                                rows={dayGroupedMatchups || []}
                                key={index}
                                currentDate={dayGroupedMatchups?.[0]?.date}
                                sport={sport}
                            />
                        ) : null
                    }
                    {sport === 'nfl' ? nflMatchups?.map((dayGroupedMatchups: BetboardRow[], index: number) =>
                            <BetboardTable
                                label={'NFL'}
                                sport={sport}
                                rows={dayGroupedMatchups || []}
                                key={index}
                                currentDate={dayGroupedMatchups?.[0]?.date}
                            />
                        ) : null
                    }
                    {sport === 'ncaafb' ? ncaafbMatchups?.map((dayGroupedMatchups: BetboardRow[], index: number) =>
                        <BetboardTable
                            label={'NCAA FB'}
                            sport={sport}
                            rows={dayGroupedMatchups || []}
                            key={index}
                            currentDate={dayGroupedMatchups?.[0]?.date}
                        />
                     ) : null
                    }
                    {sport === 'mlb' ? mlbMatchups?.map((dayGroupedMatchups: BetboardRow[], index: number) =>
                        <BetboardTable
                            label={'MLB'}
                            sport={sport}
                            rows={dayGroupedMatchups || []}
                            key={index}
                            currentDate={dayGroupedMatchups?.[0]?.date}
                        />
                    ) : null}
                    {
                        sport === 'ncaabb' && ncaabbMatchups.length ?
                            ncaabbMatchups?.map((dayGroupedMatchups: BetboardRow[], index: number) =>
                                <BetboardTable
                                    label={'NCAA BB'}
                                    sport={sport}
                                    rows={dayGroupedMatchups || []}
                                    key={index}
                                    currentDate={dayGroupedMatchups?.[0]?.date}
                                />
                            ) :
                            (sport === 'ncaabb' ? updatingDatabaseMessage : null)
                    }
                    {noGames &&
                        <Box
                            display="flex"
                            justifyContent="center"
                            px={2}
                            paddingTop={2}
                            marginTop={6.5}
                            maxHeight={100}
                            style={{background: 'white', boxShadow: `.25px .25px .25px .25px ${theme.palette.grey[500]}`}}
                            flex={1}
                            width={'100%'}
                            borderRadius={'4px'}
                            color={theme.palette.grey[800]}
                        >
                            <Typography variant="body1">
                                We have reached the end of the season for the sports we track. Use the query tool to
                                perform research for upcoming seasons, and check back in August!
                            </Typography>
                        </Box>
                    }
                </Grid>
        }
            <TrendCardsColumn
                trends={defaultTrends || []}
                sport={sport}
                loading={defaultTrendsLoading}
            />
        </Grid>
        </Box>
        </>
    );

}

export default HomePage;
